import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/reduxTypes';
import { LoadingWrapper } from '../../Loading';
import RowDivider from '../../RowDivider';
import { StripeConnectForm } from '../../StripeConnectForm';
import { SettingsPageRow } from '../SettingsPageRow';
import { BankingDefaultsSettings } from './BankingDefaultsSettings';
import { BankingDefaultsSettingsDescription } from './BankingDefaultsSettingsDescription';
import { BankingStatusSettingsDescription } from './BankingStatusSettingsDescription';

export const BankingPage: React.FC = () => {
  const isLoading = useSelector((state: RootState) => state.settings.loading);

  return (
    <LoadingWrapper isLoading={isLoading} hideContentWhileLoading>
      <>
        {/** BANK STATUS SECTION */}
        <SettingsPageRow
          description={<BankingStatusSettingsDescription />}
          hideDivider
        >
          <StripeConnectForm />
        </SettingsPageRow>
        {/** BANKING DEFAULTS SECTION */}
        <RowDivider />
        <SettingsPageRow description={<BankingDefaultsSettingsDescription />}>
          <BankingDefaultsSettings />
        </SettingsPageRow>
      </>
    </LoadingWrapper>
  );
};
